var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnepurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: 0.907227,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#513CCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4712 21.5072V41.3472H38.2792V43.9072H27.0152V41.3472H31.5912V25.1872L27.3032 28.4192L25.7352 26.2752L32.3592 21.5072H34.4712Z",
    fill: "#F2F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnepurple);
export default __webpack_public_path__ + "static/media/onepurple.25957d1a79ef63479ebf6afba6677160.svg";
export { ForwardRef as ReactComponent };